import {
  StreakButtonElementData,
  StreakButtonUpdater,
  StreakUpdaterCallback,
} from 'frontend/types/lessons/streaks';

export default class LessonStreakUpdater implements StreakButtonUpdater {
  callback: StreakUpdaterCallback | null = null;
  update(data: StreakButtonElementData): void {
    if (this.callback !== null) {
      this.callback(data);
    }
  }
}
